import { cn } from "../lib/utils";
import React from "react";
/**
 * Bordered container with a sticky top bar and focus states.
 * Use for editors, forms, or any content that needs a toolbar header.
 *
 * @example
 * ```tsx
 * <ContainerWithTopBar
 *   topBar={<MyToolbar />}
 *   error={hasError}
 * >
 *   <EditorContent editor={editor} />
 * </ContainerWithTopBar>
 * ```
 */
export function ContainerWithTopBar({
  children,
  topBar,
  error = false,
  className
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: cn("flex w-full flex-col", "rounded-xl border bg-muted-background transition-all duration-200", "border-border", "focus-within:border-border-focus", "focus-within:outline-hidden focus-within:ring-2", "focus-within:ring-highlight/20", "min-h-40", error && "border-warning-500", className)
  }, /*#__PURE__*/React.createElement("div", {
    className: cn("sticky top-0 z-10 flex items-center rounded-t-xl", "border-b border-border", "bg-muted-background/80 backdrop-blur-sm")
  }, topBar), children);
}
//# sourceMappingURL=ContainerWithTopBar.js.map